module.exports = __webpack_public_path__ + "img/back lapped zipper length.4001ea83.png";